<template>
    <div class="r-auth-register container">
        <h2>Create account</h2>
        <div class="row justify-content-center">
            <form
                class="col-lg-7"
                @submit.prevent="handleSubmit"
            >
                <h4 class="mt-4 mb-4">Personal data</h4>

                <base-select
                    name="whoAreYou"
                    label="Who are you?"
                    v-validate="'required'"
                    v-model="data.role"
                    :options="userRoles"
                    :err="errors.collect('role')"
                />

                <base-text
                    name="name"
                    label="Full name"
                    v-validate="'required'"
                    v-model="data.name"
                    :err="errors.collect('name')"
                />

                <base-text
                    name="email"
                    label="Email address"
                    v-validate="'required|email'"
                    v-model="data.email"
                    :err="errors.collect('email')"
                />

                <base-text
                    name="password"
                    type="password"
                    label="Password"
                    ref="password"
                    v-validate="'required|min:6'"
                    v-model="data.password"
                    :err="errors.collect('password')"
                />

                <base-text
                    name="c_password"
                    type="password"
                    label="Confirm password"
                    v-validate="'required|confirmed:password'"
                    data-vv-as="password"
                    v-model="data.c_password"
                    :err="errors.collect('c_password')"
                />

                <div v-if="isRecycler">
                    <p>Are you measuring at the INPUT (incoming waste) or at the OUTPUT (recyclate as a product) of your recycling process</p>

                    <div class="d-flex">
                        <div class="base-control base-checkbox form-group">
                            <input name="is_input" id="input_user" v-validate="'required'" class="styled-checkbox" type="radio" :value="1" v-model="data.is_input">
                            <label style="font-weight: normal;" class="mb-0" for="input_user">Input</label>
                        </div>

                        <div class="base-control base-checkbox form-group ml-4">
                            <input name="is_input" id="output_user" v-validate="'required'" class="styled-checkbox" type="radio" :value="0" v-model="data.is_input">
                            <label style="font-weight: normal;" class="mb-0" for="output_user">Output</label>
                        </div>
                    </div>
                    <div class="invalid-feedback d-inline-block absolute-right-errors" v-show="errors.has('is_input')"><p class="error mb-0">{{ errors.first('is_input') }}</p></div>
                </div>

                <div class="row mt-4">
                    <div class="col-6 text-left">
                        <base-button
                            radius="bl"
                            component-class="blue"
                            @click.native="$router.push({ name: 'auth-login' })"
                        ><i class="fas fa-arrow-left mr-3"></i> Login
                        </base-button>
                    </div>
                    <div class="col-6 text-right">
                        <base-button
                            radius="br"
                            component-class="green filled"
                            type="submit"
                        > Next <i class="fas fa-arrow-right ml-3"></i>
                        </base-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import BaseButton from '@/components/inputs/button/BaseButton';
    import BaseText from '@/components/inputs/text/BaseText';
    import BaseSelect from '@/components/inputs/select/BaseSelect';
    import constances from '@/configs/constances';

    export default {
        data() {
            return {
                data: {
                    role: {},
                    name: '',
                    email: '',
                    password: '',
                    c_password: '',
                    is_input: null,
                }
            };
        },

        computed: {
            ...mapState({
                userRoles: state => state.app.userRoles,
                authData: state => state.auth ? state.auth.data : {},
            }),
            isRecycler() {
                return this.data.role.value === constances.roles.RECYCLER;
            },
            isRepresentative() {
                return this.data.role.value === constances.roles.REPRESENTATIVE;
            },
        },

        watch: {
            isRecycler(newValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.data.is_input = null;
                    });
                }
            }
        },

        methods: {
            async handleSubmit() {
                try {
                    const isValidForm = await this.$validator.validateAll();
                    if (isValidForm) {
                        this.$store.commit('auth/setAuthData', this.data);

                        if (this.isRepresentative) {
                            const { role, name, email, password } = this.data;

                            const credentials = {
                                role_id: role.value,
                                name,
                                email,
                                password,
                            };

                            const isRegistered = await this.$store.dispatch('auth/register', credentials);
                            if (isRegistered) {
                                this.$router.push({ name: 'auth-login'});
                            }
                        } else {
                            this.redirectToSecondStep();
                        }

                    }
                } catch (error) {
                    console.error(error);
                }
            },
            redirectToSecondStep() {
                switch (this.data.role.value) {
                    case constances.roles.REPRESENTATIVE:
                        // TODO remove this view
                        // this.$router.push({ name: 'auth-register-companies-list' });
                        break;

                    case constances.roles.SECTOR_ASSOCIATION_REPRESENTATIVE:
                        this.$router.push({ name: 'auth-register-association-representative' });
                        break;

                    default:
                        this.$router.push({ name: 'auth-register-company' });
                        break;
                }
            }
        },

        mounted() {
            this.data = { ...this.data, ...this.authData };
        },

        components: {
            'base-button': BaseButton,
            'base-text': BaseText,
            'base-select': BaseSelect,
        }
    };
</script>
